import { Injectable } from '@angular/core';
import { NgForage } from 'ngforage';
import semaphore from 'semaphore';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import SemaphoreHelper from 'src/app/helpers/semaphore-helper';

@Injectable({
  providedIn: 'root'
})
export class ImmoIPPlacerTourOrderSubmitQueueService {
  private readonly toSubmitStorageKey = 'immoToSubmitTourOrder';
  private readonly toSubmitGetSemaphore = semaphore(1);

  constructor(private ngForage: NgForage) {}

  public async getToSubmit(): Promise<number[]> {
    let toReturn: number[] = null;
    await SemaphoreHelper.use(this.toSubmitGetSemaphore, async () => {
      toReturn = await this.ngForage.getItem(this.toSubmitStorageKey);
    });
    return toReturn;
  }

  public async addToSubmit(tourId: number): Promise<void> {
    await SemaphoreHelper.use(this.toSubmitGetSemaphore, async () => {
      let toSubmit: number[] = await this.ngForage.getItem(
        this.toSubmitStorageKey
      );
      toSubmit = toSubmit != null ? toSubmit : [];
      const earlierItem = toSubmit.find(e => e === tourId);
      if (earlierItem == null) {
        toSubmit.push(tourId);
        await this.ngForage.setItem(this.toSubmitStorageKey, toSubmit);
      }
    });
  }

  public async removeToSubmit(tourId: number): Promise<void> {
    if (tourId == null) {
      return;
    }
    await SemaphoreHelper.use(this.toSubmitGetSemaphore, async () => {
      const toSubmit: number[] = await this.ngForage.getItem(
        this.toSubmitStorageKey
      );
      if (!CollectionHelper.isPopulated(toSubmit)) {
        return;
      }
      CollectionHelper.filterInPlace(toSubmit, e => e !== tourId);
      await this.ngForage.setItem(this.toSubmitStorageKey, toSubmit);
    });
  }
}
